import PermissionGate from "../../layout/PermissionGate";

const Suspend = ({ openPopup, item }) => {
  switch (item?.status) {
    case true:
      return (
        <PermissionGate required={`suspend_driver`} fallback={<></>}>
          <span
            onClick={() => {
              openPopup("change-status", {
                id: item._id,
                status: item.status,
              });
            }}
            className="btn px-3 btn-outline btn-success btn-color-white btn-sm"
            title="Suspend Driver"
          >
            <i className="bi-duotone bi-unlock fs-5"></i>
          </span>
        </PermissionGate>
      );
    case false:
      return (
        <PermissionGate required={`activate_driver`} fallback={<></>}>
          <span
            onClick={() => {
              openPopup("change-status", {
                id: item._id,
                status: item.status,
              });
            }}
            className="btn px-3 btn-outline btn-warning btn-color-white btn-sm"
            title="Activate Driver"
          >
            <i className="bi-duotone bi-lock fs-5"></i>
          </span>
        </PermissionGate>
      );
    default:
      return <span></span>;
  }
};

export default Suspend;
